import React, { forwardRef } from 'react';
import { useDateInputFinish } from '../../common/hook/useDateInputFinish';

type DatePickerInputProps = {
    fieldName: string
    errorMsg?: string
    value?: string;
    disabled?: boolean;
    placeholder?: string;
    inputClassName?: string;
    onClick?: () => void;
    onChange?: () => void;
    onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
    onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
    onFinish?: (date: Date | null) => void; // Callback when Enter is pressed or input loses focus. Called with Date for valid input, null for empty/invalid input
    dateFormat?: string; // Date format for parsing (default: ESBA_DATE_FORMAT)
    hasShadow?: boolean;
    marginL?: string;
    fullWidth?: boolean;
};

export const CustomDateInput = forwardRef<HTMLInputElement, DatePickerInputProps>(
    ({fieldName, value, onClick, onChange, errorMsg, disabled, onKeyDown, onBlur, onFinish, dateFormat, hasShadow = false, marginL = 'ml-4', fullWidth = false, placeholder, inputClassName}, ref) => {
        const { handleKeyDown, handleBlur } = useDateInputFinish({
            onFinish,
            dateFormat,
            onKeyDown,
            onBlur,
        });
        let errorCss = "";
        if (errorMsg) {
           errorCss = "border-red-500"
        }
        let shadowCss = "";
        if (hasShadow) {
            shadowCss = "shadow"
        }
        return (
            <div className={`flex items-center ${fullWidth ? 'w-full' : ''}`}>
                <input
                    className={`${marginL} border block p-1 rounded ${errorCss} ${shadowCss} ${fullWidth ? 'w-full' : ''} ${inputClassName ?? ''}`}
                    id={fieldName}
                    value={value}
                    placeholder={placeholder}
                    disabled={disabled}
                    onClick={onClick}
                    onChange={onChange}
                    onKeyDown={handleKeyDown}
                    onBlur={handleBlur}
                    ref={ref}
                />
                {
                    errorMsg &&
                    <div className="pl-4 text-red-700">
                        {errorMsg}
                    </div>
                }
            </div>
        )
    }
);
